import { AppState } from "../..";
import { Rating } from "../../../sharedComponents";

export const getRating = (state: AppState) => state.ratings.rating as Rating;
